module.exports = __webpack_public_path__ + "media/3-1.8dc96651.wav";